import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../view/Modules/Dashboard/Dashboard";
import ViewUpdateProfile from "../view/Modules/Users/UpdateProfile";
import { ContentRoutes } from "./NavConstant";
import Songs from "../view/Modules/Songs/Songs";
import Song from "../view/Modules/Songs/Song";
import { Page401 } from "../view/pages/Page401/Page401";
import Singers from "../view/Modules/Singers/Singers";
import Composers from "../view/Modules/Composers/Composers";
import Lyricists from "../view/Modules/Lyricists/Lyricists";
import Actors from "../view/Modules/Actors/Actors";
import Brands from "../view/Modules/Brands/Brands";
import Campaigns from "../view/Modules/Campaigns/Campaigns";
import Commercials from "../view/Modules/Commercials/Commercials";
import Commercial from "../view/Modules/Commercials/Commercial";
import Charts from "../view/Modules/Charts/Charts";
import Chart from "../view/Modules/Charts/Chart";
import AddSongsToChart from "../view/Modules/Charts/AddSongsToChart";
import AddSongsToMusicSchedule from "../view/Modules/MusicSchedule/AddSongsToMusicSchedule";
import MusicSchedules from "../view/Modules/MusicSchedule/MusicSchedules";
import MusicSchedule from "../view/Modules/MusicSchedule/MusicSchedule";
import CommercialSchedules from "../view/Modules/CommercialSchedule/CommercialSchedules";
import AddItemsToCommercialSchedule from "../view/Modules/CommercialSchedule/AddItemsToCommercialSchedule";
import CommercialSchedule from "../view/Modules/CommercialSchedule/CommercialSchedule";
import MediaPlayReport from "../view/Modules/Reports/MediaPlayReport";
import StoreSchedule from "../view/Modules/StoreSchedule/StoreSchedules";
import Medias from "../view/Modules/Medias/Medias";
import Media from "../view/Modules/Medias/Media";
import { MediaProvider } from "../context/MediaContext";

export default function Content() {
  return (
    <MediaProvider>
      <Routes>
        <Route path={ContentRoutes.DASHBOARD} element={<Dashboard />} />
        <Route path={ContentRoutes.SONGS} element={<Songs />} />
        <Route path={ContentRoutes.CREATE_SONG} element={<Song />} />
        <Route path={ContentRoutes.UPDATE_SONG} element={<Song />} />

        <Route path={ContentRoutes.MEDIAS} element={<Medias />} />

        <Route path={ContentRoutes.CREATE_MEDIA} element={<Media />} />
        <Route path={ContentRoutes.UPDATE_MEDIA} element={<Media />} />
        <Route path={ContentRoutes.CHARTS} element={<Charts />} />
        <Route
          path={ContentRoutes.ADD_SONGS_TO_CHART}
          element={<AddSongsToChart />}
        />
        <Route path={ContentRoutes.CREATE_CHART} element={<Chart />} />
        <Route path={ContentRoutes.UPDATE_CHART} element={<Chart />} />
        <Route
          path={ContentRoutes.MUSIC_SCHEDULES}
          element={<MusicSchedules />}
        />
        <Route
          path={ContentRoutes.ADD_SONGS_TO_MUSIC_SCHEDULE}
          element={<AddSongsToMusicSchedule />}
        />
        <Route
          path={ContentRoutes.CREATE_MUSIC_SCHEDULE}
          element={<MusicSchedule />}
        />
        <Route
          path={ContentRoutes.UPDATE_MUSIC_SCHEDULE}
          element={<MusicSchedule />}
        />
        <Route
          path={ContentRoutes.COMMERCIAL_SCHEDULES}
          element={<CommercialSchedules />}
        />
        <Route
          path={ContentRoutes.ADD_ITEMS_TO_COMMERCIAL_SCHEDULE}
          element={<AddItemsToCommercialSchedule />}
        />
        <Route
          path={ContentRoutes.CREATE_COMMERCIAL_SCHEDULE}
          element={<CommercialSchedule />}
        />
        <Route
          path={ContentRoutes.UPDATE_COMMERCIAL_SCHEDULE}
          element={<CommercialSchedule />}
        />

        <Route
          path={ContentRoutes.STORE_SCHEDULE}
          element={<StoreSchedule />}
        />

        <Route
          path={ContentRoutes.MEDIA_PLAY_REPORT}
          element={<MediaPlayReport />}
        />
        <Route path={ContentRoutes.COMMERCIALS} element={<Commercials />} />
        <Route
          path={ContentRoutes.CREATE_COMMERCIAL}
          element={<Commercial />}
        />
        <Route
          path={ContentRoutes.UPDATE_COMMERCIAL}
          element={<Commercial />}
        />
        <Route path={ContentRoutes.SINGERS} element={<Singers />} />
        <Route path={ContentRoutes.COMPOSERS} element={<Composers />} />
        <Route path={ContentRoutes.LYRICISTS} element={<Lyricists />} />
        <Route path={ContentRoutes.ACTORS} element={<Actors />} />
        <Route path={ContentRoutes.BRANDS} element={<Brands />} />
        <Route path={ContentRoutes.CAMPAIGNS} element={<Campaigns />} />
        <Route
          path={ContentRoutes.VIEW_UPDATE_PROFILE}
          element={<ViewUpdateProfile />}
        />
        <Route path={ContentRoutes.PAGE_401} element={<Page401 />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </MediaProvider>
  );
}
